<template>
  <div>
    <order-header v-model="innerValue" @getOrderList="$emit('getOrderList')">
    </order-header>

    <!-- 没有订单 -->
    <div class="none-order" v-if="orderList.length === 0">
      <img src="../../../../../assets/imgs/work-wx/customer/none-order.png" />
      <div class="none-order-text">
        {{ innerValue ? '未查询到订单' : '该用户未有订单产生' }}
      </div>
    </div>

    <!-- 有订单 -->
    <div class="order-list" v-else>
      <order-item
        v-for="(order, index) in orderList"
        :key="index"
        :order-item="order"
      >
      </order-item>
    </div>
  </div>
</template>

<script>
import OrderHeader from './components/order-header';
import OrderItem from './components/order-item/order-item';

export default {
  components: {
    OrderHeader,
    OrderItem,
  },
  props: {
    orderList: {
      type: Array,
      default: () => [],
    },
    value: String,
  },
  data() {
    return {};
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="less">
.none-order {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 88px;
    height: 88px;
    margin-top: 18px;
  }
  .none-order-text {
    margin-top: 20px;
    font-size: 12px;
    color: #c9cdd1;
  }
}
.order-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 50px;
}
.loading {
  width: 100%;
  padding-top: 100px;
  background: #f5f6f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #918f8f;
  text-align: center;
}
</style>
